class GlobalConfig {
  static instance = null;
  config = null;
  
  constructor() {
    if (GlobalConfig.instance) {
      return GlobalConfig.instance;
    }
    GlobalConfig.instance = this;
  }

  initialize(config = {}) {
    if (!this.config) {
      this.config = {
        BASE_AUTH_URL: "https://intranet.fibra360.net/api",
        ...config
      };
    }
    return this;
  }

  getBaseUrl(key = "BASE_AUTH_URL") {
    if (!this.config) {
      // Auto-inicializar con valores por defecto si no se ha inicializado
      this.initialize();
    }
    
    if (!this.config[key]) {
      throw new Error(`Key "${key}" does not exist in the global config.`);
    }

    return this.config[key];
  }
  
  // Mantener compatibilidad con tu código existente
  get() {
    return this.config;
  }
  
  set(value) {
    this.initialize(value);
  }
}

export const getFullUrl = (path) => {
  const baseUrl = globalConfig.getBaseUrl();
  if (!path.startsWith("/")) {
    path = `/${path}`;
  }
  return `${baseUrl}${path}`;
};

export const globalConfig = new GlobalConfig();

// Ahora puedes inicializarla donde sea conveniente, pero si no lo haces,
// se usarán los valores por defecto automáticamente